var _mask, _rect, _path, _mask2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHourglass = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "hourglass_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 4,
  x: 4,
  y: 1,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 4,
  x: 4,
  y: 1,
  mask: "url(#hourglass_svg__a)",
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 5v2.28a1 1 0 0 0 .427.819l5 3.5a1 1 0 0 0 1.146 0l5-3.5a1 1 0 0 0 .427-.82V5M18 19v-2.28a1 1 0 0 0-.427-.819l-5-3.5a1 1 0 0 0-1.146 0l-5 3.5a1 1 0 0 0-.427.82V19"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "hourglass_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 4,
  x: 20,
  y: 23,
  rx: 1
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 4,
  x: 20,
  y: 23,
  mask: "url(#hourglass_svg__b)",
  rx: 1,
  transform: "rotate(-180 20 23)"
})));
SvgHourglass.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgHourglass);
export default ForwardRef;